import { HttpClient } from "@angular/common/http";
import { InjectionToken } from "@angular/core";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
// Import from the swappable loader file
// angular.json fileReplacements will swap this for server build
import { createTranslateLoader } from "./translate-loader";


export interface ILanguageFileSetting {
	languages: string[];
	basePath: string;
}

export const LanguageFileSetting = new InjectionToken<ILanguageFileSetting>('language');

/**
 * Factory function that creates the appropriate translation loader.
 * The actual loader implementation is determined by the build configuration:
 * - Browser build: uses translate-loader.ts (HTTP-based)
 * - Server build: uses translate-loader.server.ts (filesystem-based)
 */
export function TranslateModuleLoaderFactory(
	http: HttpClient,
	languageFileSetting: ILanguageFileSetting
) {
	return createTranslateLoader(http, {
		basePath: languageFileSetting.basePath,
		modules: languageFileSetting.languages
	});
}

export class TranslateModuleLoader {
	constructor() {}
	
	public static forRoot() {
		return TranslateModule.forRoot({
			defaultLanguage: 'tc',
			useDefaultLang: true,
			loader: {
				provide: TranslateLoader,
				useFactory: TranslateModuleLoaderFactory,
				deps: [
					HttpClient,
					LanguageFileSetting
				]
			}
		});
	}
}

